// Procedural sound scenes per sales channel (Web Audio, no assets).
let ctx = null;
let ambience = null;

const AC = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  ctx.resume?.();
  return ctx;
};

const noiseBuffer = (c, seconds = 2, brown = false) => {
  const buf = c.createBuffer(1, c.sampleRate * seconds, c.sampleRate);
  const d = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < d.length; i++) {
    const w = Math.random() * 2 - 1;
    if (brown) { last = (last + 0.02 * w) / 1.02; d[i] = last * 3.5; } else d[i] = w;
  }
  return buf;
};

const tone = (c, dest, freq, t0, dur, gain = 0.2, type = "sine") => {
  const o = c.createOscillator(); const g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  o.connect(g).connect(dest); o.start(t0); o.stop(t0 + dur + 0.05);
};

const thud = (c, dest, t0, gain = 0.5) => {
  const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 0.2);
  const f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 180;
  const g = c.createGain();
  g.gain.setValueAtTime(gain, t0); g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.12);
  s.connect(f).connect(g).connect(dest); s.start(t0); s.stop(t0 + 0.2);
};

const INTROS = {
  door_to_door: (c, d, t) => { // ding-dong doorbell, then a beat
    tone(c, d, 659, t, 0.9, 0.18); tone(c, d, 1318, t, 0.5, 0.05);
    tone(c, d, 523, t + 0.45, 1.1, 0.18); tone(c, d, 1046, t + 0.45, 0.6, 0.05);
    return 1.9;
  },
  in_home: (c, d, t) => { // knock knock, door opens (soft creak)
    thud(c, d, t); thud(c, d, t + 0.18); thud(c, d, t + 0.36, 0.4);
    const o = c.createOscillator(); const g = c.createGain();
    o.type = "sawtooth"; o.frequency.setValueAtTime(90, t + 0.9); o.frequency.linearRampToValueAtTime(140, t + 1.5);
    const f = c.createBiquadFilter(); f.type = "bandpass"; f.frequency.value = 400; f.Q.value = 6;
    g.gain.setValueAtTime(0.0001, t + 0.9); g.gain.linearRampToValueAtTime(0.03, t + 1.1); g.gain.linearRampToValueAtTime(0.0001, t + 1.6);
    o.connect(f).connect(g).connect(d); o.start(t + 0.9); o.stop(t + 1.7);
    return 1.9;
  },
  phone: (c, d, t) => { // UK ring: 0.4 on, 0.2 off, 0.4 on — one ring, then pickup click
    [0, 0.6].forEach((o) => { tone(c, d, 400, t + o, 0.4, 0.06, "square"); tone(c, d, 450, t + o, 0.4, 0.06, "square"); });
    thud(c, d, t + 1.9, 0.25);
    return 2.2;
  },
  retail: (c, d, t) => { // entrance chime
    tone(c, d, 880, t, 0.6, 0.08); tone(c, d, 1108, t + 0.18, 0.7, 0.08); tone(c, d, 1318, t + 0.36, 0.9, 0.08);
    return 1.4;
  },
};

const AMBIENCE = {
  door_to_door: (c, d) => { // outdoor air + distant birds
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 3, true); s.loop = true;
    const f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 500;
    const g = c.createGain(); g.gain.value = 0.045;
    s.connect(f).connect(g).connect(d); s.start();
    const timer = setInterval(() => { if (Math.random() < 0.5) { const t = c.currentTime; tone(c, d, 2800 + Math.random() * 1200, t, 0.12, 0.012); tone(c, d, 3200 + Math.random() * 800, t + 0.15, 0.1, 0.01); } }, 2500);
    return () => { s.stop(); clearInterval(timer); };
  },
  in_home: (c, d) => { // room tone + clock tick
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 3, true); s.loop = true;
    const f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 250;
    const g = c.createGain(); g.gain.value = 0.035;
    s.connect(f).connect(g).connect(d); s.start();
    const timer = setInterval(() => thud(c, d, c.currentTime, 0.05), 1000);
    return () => { s.stop(); clearInterval(timer); };
  },
  phone: (c, d) => { // line hiss
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 2); s.loop = true;
    const f = c.createBiquadFilter(); f.type = "bandpass"; f.frequency.value = 1800; f.Q.value = 0.6;
    const g = c.createGain(); g.gain.value = 0.012;
    s.connect(f).connect(g).connect(d); s.start();
    return () => s.stop();
  },
  retail: (c, d) => { // showroom hum + crowd murmur
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 3, true); s.loop = true;
    const f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 400;
    const g = c.createGain(); g.gain.value = 0.05;
    s.connect(f).connect(g).connect(d); s.start();
    const m = c.createBufferSource(); m.buffer = noiseBuffer(c, 2); m.loop = true;
    const mf = c.createBiquadFilter(); mf.type = "bandpass"; mf.frequency.value = 600; mf.Q.value = 1.2;
    const mg = c.createGain(); mg.gain.value = 0.02;
    const lfo = c.createOscillator(); lfo.frequency.value = 0.3; const lg = c.createGain(); lg.gain.value = 0.012;
    lfo.connect(lg).connect(mg.gain); lfo.start();
    m.connect(mf).connect(mg).connect(d); m.start();
    return () => { s.stop(); m.stop(); lfo.stop(); };
  },
};

const keyFor = (channel) => (channel === "phone_cold" || channel === "phone_followup" ? "phone" : channel);

export const isPhone = (channel) => keyFor(channel) === "phone";

const ENDINGS = {
  door_to_door: (c, d, t) => { // door slam + latch
    thud(c, d, t, 0.9); thud(c, d, t + 0.03, 0.7);
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 0.3);
    const f = c.createBiquadFilter(); f.type = "bandpass"; f.frequency.value = 900; f.Q.value = 1.5;
    const g = c.createGain(); g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.25);
    s.connect(f).connect(g).connect(d); s.start(t); s.stop(t + 0.3);
    tone(c, d, 2400, t + 0.32, 0.08, 0.06, "square");
    return 1.2;
  },
  in_home: (c, d, t) => { // chair scrape + door close
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 0.5, true);
    const f = c.createBiquadFilter(); f.type = "bandpass"; f.frequency.value = 300; f.Q.value = 2;
    const g = c.createGain(); g.gain.setValueAtTime(0.2, t); g.gain.linearRampToValueAtTime(0.0001, t + 0.45);
    s.connect(f).connect(g).connect(d); s.start(t); s.stop(t + 0.5);
    thud(c, d, t + 0.9, 0.7);
    return 1.5;
  },
  phone: (c, d, t) => { // hang-up click then UK dial tone
    thud(c, d, t, 0.3);
    tone(c, d, 350, t + 0.35, 1.6, 0.05); tone(c, d, 450, t + 0.35, 1.6, 0.05);
    return 2.1;
  },
  retail: (c, d, t) => { // footsteps walking away
    for (let i = 0; i < 5; i++) thud(c, d, t + i * 0.42, 0.35 - i * 0.06);
    return 2.4;
  },
};

export function playEnding(channel) {
  return new Promise((resolve) => {
    try {
      const c = AC();
      const fn = ENDINGS[keyFor(channel)] || ENDINGS.door_to_door;
      const dur = fn(c, c.destination, c.currentTime + 0.05);
      setTimeout(resolve, dur * 1000);
    } catch { resolve(); }
  });
}

export function playIntro(channel) {
  return new Promise((resolve) => {
    try {
      const c = AC();
      const fn = INTROS[keyFor(channel)] || INTROS.door_to_door;
      const dur = fn(c, c.destination, c.currentTime + 0.05);
      setTimeout(resolve, dur * 1000);
    } catch { resolve(); }
  });
}

export function startAmbience(channel) {
  stopAmbience();
  try {
    const c = AC();
    const fn = AMBIENCE[keyFor(channel)] || AMBIENCE.door_to_door;
    const master = c.createGain(); master.gain.value = 0.0001;
    master.connect(c.destination);
    master.gain.exponentialRampToValueAtTime(1, c.currentTime + 1.5);
    const stop = fn(c, master);
    ambience = () => {
      try { master.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.6); } catch (err) { console.warn("[soundScene] ignored error", err); }
      setTimeout(() => { try { stop(); master.disconnect(); } catch (err) { console.warn("[soundScene] ignored error", err); } }, 700);
    };
  } catch (err) { console.warn("[soundScene] ignored error", err); }
}

export function stopAmbience() {
  if (ambience) { ambience(); ambience = null; }
}

// Route an <audio> element through a telephone band-pass so the customer sounds like they're on the line.
export function phoneEq(c, source) {
  const hp = c.createBiquadFilter(); hp.type = "highpass"; hp.frequency.value = 300;
  const lp = c.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 3400;
  const peak = c.createBiquadFilter(); peak.type = "peaking"; peak.frequency.value = 1800; peak.gain.value = 4; peak.Q.value = 1;
  const shaper = c.createWaveShaper();
  const curve = new Float32Array(256);
  for (let i = 0; i < 256; i++) { const x = (i / 128) - 1; curve[i] = Math.tanh(x * 1.6) / Math.tanh(1.6); }
  shaper.curve = curve;
  source.connect(hp).connect(lp).connect(peak).connect(shaper);
  return shaper;
}
